<script>
import { provide, ref } from 'vue'

export default {
  name: 'VcMain',
  setup() {
    const isReload = ref(false)

    function reloadPage() {
      isReload.value = true
      setTimeout(() => {
        isReload.value = false
      })
    }

    provide('reloadPage', reloadPage)

    return {
      isReload,
    }
  },
}
</script>

<template>
  <ElMain>
    <KeepAlive>
      <RouterView v-if="$route.meta.keepAlive && !isReload" />
    </KeepAlive>
    <RouterView v-if="!$route.meta.keepAlive && !isReload" />
  </ElMain>
</template>

<style lang="scss" scoped>
.el-main {
  overflow: auto;
}
</style>
